import { Flex } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useEsriMapStore } from '../hooks/use-esri-map-store';
import { MapEntityDetails } from './map-entity-details/map-entity-details';
import { useApplicationType } from '../../common/hooks/use-application-type';
import {
    PROPERTIES_PANEL_MARGIN_TOP,
    PROPERTIES_PANEL_WIDTH,
    FR_PROPERTIES_PANEL_MARGIN_TOP,
    FR_PROPERTIES_PANEL_WIDTH,
} from '../../esri/constants';

export const MapLedger = observer(function MapLedger(): React.ReactElement | null {
    const mapStore = useEsriMapStore();
    const { isFirstResponder } = useApplicationType();

    if (!mapStore.isMapLedgerOpen) {
        return null;
    }

    return (
        <Flex
            data-testid="MAP_LEDGER"
            height="100%"
            width={isFirstResponder ? FR_PROPERTIES_PANEL_WIDTH : PROPERTIES_PANEL_WIDTH}
            marginTop={
                isFirstResponder ? FR_PROPERTIES_PANEL_MARGIN_TOP : PROPERTIES_PANEL_MARGIN_TOP
            }
            backgroundColor="surface.accent"
            borderRightWidth="1px"
            borderStyle="solid"
            borderColor="border.default"
            overflowY="auto"
        >
            <MapEntityDetails />
        </Flex>
    );
});
